import { booleanAttribute, Component, computed, input, output } from '@angular/core';
import { faClock, faTimes } from '@fortawesome/free-solid-svg-icons';
import { CommunicationLevel, HeadOfficeInfo } from '../../services/communications/models';
import { formatParisDate } from '../../services/communications/utils/communication-date';

@Component({
  selector: 'ng-casto-communication-alert-dialog',
  templateUrl: './communication-alert-dialog.component.html',
})
export class CommunicationAlertDialogComponent {
  readonly alert = input.required<HeadOfficeInfo>();
  readonly preview = input(false, { transform: booleanAttribute });
  readonly canNavigate = input(false, { transform: booleanAttribute });
  readonly currentPosition = input(1);
  readonly totalAlerts = input(1);

  readonly closed = output<void>();
  readonly acknowledged = output<void>();
  readonly previousRequested = output<void>();
  readonly nextRequested = output<void>();

  protected readonly CommunicationLevel = CommunicationLevel;
  protected readonly faClock = faClock;
  protected readonly faTimes = faTimes;
  protected readonly formatParisDate = formatParisDate;
  protected readonly titleId = computed(() =>
    `${this.preview() ? 'admin-alert-preview-title' : 'alert-title'}-${this.alert().id}`
  );
  protected readonly dialogAriaLabelKey = computed(() =>
    this.preview() ? 'communications.admin.previewDialogAria' : 'communications.header.alertDialogAria'
  );

  protected levelLabelKey(level: CommunicationLevel): string {
    if (level === CommunicationLevel.StrongAlert) return 'communications.level.strong';
    if (level === CommunicationLevel.ModerateAlert) return 'communications.level.moderate';
    return 'communications.level.information';
  }

  protected levelShortLabelKey(level: CommunicationLevel): string {
    if (level === CommunicationLevel.StrongAlert) return 'communications.level.strongShort';
    return this.levelLabelKey(level);
  }

  protected close(): void {
    this.closed.emit();
  }

  protected acknowledge(): void {
    if (!this.preview()) this.acknowledged.emit();
  }
}
